import React, { Component } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import MenuIcon from "@material-ui/icons/Menu";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import { PublishHierarchy } from "../services/hierarchyService";
import { PublishTransactions } from "../services/transactionService";
import VerifyRole from "./VerifyRole";
import { UserRoleTypeEnum } from "../services/authService";
import Publish from "./Publish";

class AppBarTop extends Component {
  handlePublish = () => {
    const { hierarchyType } = this.props;
    PublishHierarchy(hierarchyType.id);
  };

  handlePublishTrans = () => {
    const { hierarchyType } = this.props;
    PublishTransactions();
  };

  render() {
    const {
      classes,
      open,
      handleDrawerOpen,
      hierarchyType,
      publishTrans
    } = this.props;

    return (
      <AppBar
        position="absolute"
        className={clsx(classes.appBar, open && classes.appBarShift)}
      >
        <Toolbar className={classes.toolbar}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="Open drawer"
            onClick={() => handleDrawerOpen()}
            className={clsx(
              classes.menuButton,
              open && classes.menuButtonHidden
            )}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
            className={classes.title}
          >
            Finance Reporting Management
          </Typography>
          {hierarchyType && (
            <VerifyRole requiredRoles={[UserRoleTypeEnum.Administrator]}>
              <Publish
                title="Publish Hierarchy"
                message={`Are you sure you want to publish the ${
                  hierarchyType.name
                } Hierarchy?`}
                publish={this.handlePublish}
              />
            </VerifyRole>
          )}
          {publishTrans && (
            <VerifyRole requiredRoles={[UserRoleTypeEnum.Administrator]}>
              <Publish
                title="Publish Transactions"
                message={`Are you sure you want to publish the transactions?`}
                publish={this.handlePublishTrans}
              />
            </VerifyRole>
          )}
        </Toolbar>
      </AppBar>
    );
  }
}

AppBarTop.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  handleDrawerOpen: PropTypes.func.isRequired
};

export default AppBarTop;
